import { render } from "./EditArticleView.vue?vue&type=template&id=1b6bb9f2"
import script from "./EditArticleView.vue?vue&type=script&lang=js"
export * from "./EditArticleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__